import * as schema from "@/shared/state/visualization/schema/v1/three-d";

/**
 * Pick a default entity to target when the camera spec does not name
 * one. Used by the mode toggle (orbit → thirdPerson seed) and the
 * recenter button (third-person → orbit-style framing reset). Takes the
 * first entity, in insertion order, that carries a mesh, a path or a point
 * cloud; the order between the three applies only within one entity, which
 * is targeted by its mesh before its path and by its path before its cloud.
 * Returns `undefined` when no entity carries any of them.
 *
 * The target names the component as the camera schema does, so the camera
 * settings offer and show it under the same name: a cloud-only entity is
 * `lidar.pointCloud`, not a `lidar.mesh` the entity does not have.
 */
export function resolveFallbackEntity(
  entities: Record<schema.EntityID, schema.Entity>,
): { id: schema.EntityID; mesh: schema.OrbitTargetKind } | undefined {
  for (const [id, entity] of Object.entries(entities)) {
    if (entity.mesh) {
      return { id, mesh: "mesh" };
    }
    if (entity.path) {
      return { id, mesh: "path" };
    }
    if (entity.pointCloud) {
      return { id, mesh: "pointCloud" };
    }
  }
  return undefined;
}
